var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-form',{attrs:{"endpoint":"almox-fornecedor","rota-base":"/admin/almox-fornecedor","titulo-singular":"Fornecedor","campos-extras":_vm.camposExtras}})
}
var staticRenderFns = []

export { render, staticRenderFns }